import React, { useEffect, useState } from "react";
import WebsiteComponent from "./website.component";

import { useSelector } from "react-redux";
import apiLinkPreview from "app/api/linkpreview";

export default function WebsiteContainer({ id, currentLanguage, isTemplateEditor, getTranslation }) {
  const {
    isVisible,
    content: { URL, descriptions }
  } = useSelector(state => isTemplateEditor
    ? state.products.template.workspaceSetting.setting.components[id]
    : state.productPage.components[id]);
  const description = descriptions.find((e) => e.lang === currentLanguage).value;
  const [isFetching, setFetching] = useState(false);
  const [error, setError] = useState("");
  const [metadata, setMetadata] = useState({
    desc: "",
    image: "",
    favicon: "",
    title: ""
  });

  useEffect(() => {
    const siteUrl = URL;
    if (siteUrl !== "" && isVisible) {
      setFetching(true);
      (async function () {
        const response = await apiLinkPreview(siteUrl);

        const isSuccess =
          typeof response.data !== "string" && response.data !== "Fail";

        if (!isSuccess) {
          setError("Invalid url");
          setFetching(false);
          return;
        }

        const { description = "", title = "", image = "", favicon = "" } = response.data.data || {};

        let finalFavicon = favicon;
        try {
          if (!finalFavicon && siteUrl) {
            finalFavicon = new window.URL("/favicon.ico", siteUrl).href;
          }
        } catch (e) {
          console.warn("Failed to build fallback favicon:", e);
        }

        setFetching(false);
        setError("");
        setMetadata({
          desc: description,
          image,
          favicon: finalFavicon,
          title
        });
      })();
    }
  }, [URL, isVisible]);

  return (
    isVisible && (
      <WebsiteComponent
        isFetching={isFetching}
        error={error}
        url={URL}
        desc={description}
        alt_desc={metadata.desc}
        title={metadata.title}
        image={metadata.image}
        favicon={metadata.favicon}
        getTranslation={getTranslation}
      />
    )
  );
}
